import React, { useEffect, useMemo, useRef, useState } from "react";
import axios from "axios";
import "./StampAgr.scss";
import { connect } from "react-redux";
import { customerService } from "../../services";

const HOME_ICON = {
    1: "/images/expo/S1.png",
    2: "/images/expo/S2.png",
    3: "/images/expo/S3.png",
};
const Stamp_ICON = {
    1: "/images/expo/Stamp1.png",
    2: "/images/expo/Stamp2.png",
    3: "/images/expo/Stamp3.png",
};

const MISSION_META = {
    1: { no: 1, code: "MISSION 1", icon: HOME_ICON[1], Stamp: Stamp_ICON[1] },
    2: { no: 2, code: "MISSION 2", icon: HOME_ICON[2], Stamp: Stamp_ICON[2] },
    3: { no: 3, code: "MISSION 3", icon: HOME_ICON[3], Stamp: Stamp_ICON[3] },
};

const ASSET = {
    home: "/images/expo/S0.png",
    pass: "/images/expo/S0.png",
    passBlack: "/images/expo/S0.png",
    question: "/images/expo/mission-question-intro.png",
    loading: "/images/expo/loading_black.gif",
};




// util: preload
const preloadImages = (urls = []) =>
    Promise.all(
        urls
            .filter(Boolean)
            .map(
                (src) =>
                    new Promise((resolve) => {
                        const img = new Image();
                        img.onload = resolve;
                        img.onerror = resolve;
                        img.src = src;
                    })
            )
    );

function StampAgr({ profile }) {
    const customerLS = useMemo(() => {
        try {
            const raw = localStorage.getItem("customer");
            return raw ? JSON.parse(raw) : null;
        } catch {
            return null;
        }
    }, []);

    const [screen, setScreen] = useState("home");
    const [passedMissionSet, setPassedMissionSet] = useState(new Set());
    const [currentMission, setCurrentMission] = useState(null);
    const [selectedMission, setSelectedMission] = useState(null);

    const [amwayNumber, setAmwayNumber] = useState(null);
    const [partyId, setPartyId] = useState(null);

    const [passDigits, setPassDigits] = useState(["", "", "", ""]);
    const [missionPasswords, setMissionPasswords] = useState({ 1: [], 2: [], 3: [] });
    const [isCheckingPass, setIsCheckingPass] = useState(false);


    const [answers, setAnswers] = useState({});
    const [allCorrect, setAllCorrect] = useState(false);
    const [checked, setChecked] = useState(false);

    const passRefs = useRef([]);

    const [bgReady, setBgReady] = useState(false);

    const passCode = useMemo(() => passDigits.join(""), [passDigits]);
    const passComplete = useMemo(() => passDigits.every((d) => d !== ""), [passDigits]);

    const [pageReady, setPageReady] = useState(false);
    const [staffReady, setStaffReady] = useState(false);
    const [customerReady, setCustomerReady] = useState(false);
    const [passedReady, setPassedReady] = useState(false);
    const [passedFetched, setPassedFetched] = useState(false);
    const [cusNotfound, setCusNotfound] = useState(false);
    const dataReady = staffReady && customerReady && passedReady;
    const [errorText, setErrorText] = useState("");
    useEffect(() => {
        let cancelled = false;

        const run = async () => {
            await new Promise((r) => requestAnimationFrame(() => requestAnimationFrame(r)));
            try {
                if (document.fonts?.ready) await document.fonts.ready;
            } catch { }

            if (!cancelled) setPageReady(true);
        };

        run();
        return () => { cancelled = true; };
    }, []);
    const resetPass = () => setPassDigits(["", "", "", ""]);

    // bg per screen
    const bgSrc = useMemo(() => {
        const map = {
            home: ASSET.home,
            pass: ASSET.pass,
            passBlack: ASSET.passBlack,
            question: ASSET.question,
        };

        return map[screen] || ASSET.home;
    }, [screen]);

    // preload ทั้งชุด (ครั้งเดียว)
    useEffect(() => {
        const urls = [
            ...Object.values(ASSET),
            ...Object.values(HOME_ICON),
        ];
        preloadImages(urls);
    }, []);

    // preload เฉพาะ bgSrc ที่กำลังจะโชว์ เพื่อเปิด bgReady
    useEffect(() => {
        setBgReady(false);
        const img = new Image();
        img.onload = () => setBgReady(true);
        img.onerror = () => setBgReady(true);
        img.src = bgSrc;
    }, [bgSrc]);


    useEffect(() => {
        const el = document.getElementById("wrapper");
        if (!el) return;

        el.classList.add("expo-full");
        return () => el.classList.remove("expo-full");
    }, []);

    useEffect(() => {
        if (!passedFetched) return;
        setPassedReady(true);
    }, [passedFetched]);

    // ===== customer from LS =====
    useEffect(() => {
        if (customerLS?.amwayNumber && !amwayNumber) setAmwayNumber(customerLS.amwayNumber);
        if (customerLS?.partyId && !partyId) setPartyId(customerLS.partyId);

    }, [customerLS, amwayNumber, partyId]);

    // ===== customer log =====
    useEffect(() => {
        let cancelled = false;

        const fetchCustomer = async () => {

            if (profile == null) return;

            if (!profile?.userId) {
                if (!cancelled) setCustomerReady(true);
                return;
            }

            try {
                const c = await customerService.get(profile.userId);

                if (!c?.amwayNumber || c?.type !== 'abo') {

                    setCusNotfound(true);

                    setSelectedMission({
                        no: 0,
                        Stamp: "/images/expo/ExpoNotuse.png"
                    });

                    setPassedFetched(true);
                    setStaffReady(true);
                    setCustomerReady(true);

                    setScreen("pass");
                    return;
                }

                if (!c?.amwayNumber) return;

                if (!cancelled) {
                    setAmwayNumber(c.amwayNumber);
                    setPartyId(c.partyId);
                }

                const res = await axios.post(`${process.env.REACT_APP_API_URL}/customers/expo`, {
                    uid: c.uid,
                    amwayNumber: c.amwayNumber,
                    partyId: c.partyId,
                    type: "S",
                });

                const logs = Array.isArray(res.data?.customerLog) ? res.data.customerLog : [];



                const nextSet = new Set();
                logs.forEach((l) => {
                    const t = String(l.type || "").toUpperCase();
                    if (t.startsWith("S")) {
                        const no = Number(t.replace("S", ""));
                        if (!Number.isNaN(no)) nextSet.add(no);
                    }
                });

                if (!cancelled) {
                    setPassedMissionSet(nextSet);
                    setPassedFetched(true);
                }

                if (!staffReady) {
                    try {
                        const staffRes = await axios.post(`${process.env.REACT_APP_API_URL}/customers/expo_staff`, {});
                        const rows = Array.isArray(staffRes.data) ? staffRes.data : [];

                        const temp = { 1: [], 2: [], 3: [] };
                        rows.forEach((r) => {
                            const type = String(r.type || "").toLowerCase();
                            const clean = String(r.amwayNumber || "").replace(/\D/g, "");
                            if (clean.length !== 4) return;

                            if (type === "s1") temp[1].push(clean);
                            if (type === "s2") temp[2].push(clean);
                            if (type === "s3") temp[3].push(clean);

                        });

                        if (!cancelled) setMissionPasswords(temp);
                    } catch (e) {
                        console.error("fetchStaff error", e);
                    } finally {
                        if (!cancelled) setStaffReady(true);
                    }
                }
            } catch (e) {
                console.error("fetchCustomer error", e);
            } finally {
                if (!cancelled) setCustomerReady(true);
            }
        };

        fetchCustomer();
        return () => { cancelled = true; };
    }, [profile?.userId]);


    const onClickฺBack = () => {
        setErrorText("");
        resetPass();
        setSelectedMission(null);
        setScreen("home");
        setIsCheckingPass(false);
    };


    const submitPassSuccess = async () => {
        try {
            if (!amwayNumber || !partyId) return;
            await axios.post(`${process.env.REACT_APP_API_URL}/customers/expo_pass`, {
                uid: profile.userId,
                amwayNumber,
                partyId,
                type: `S${currentMission}`,
            });
        } catch (e) {
            console.error("expo_pass error", e);
        }
    };

    // ===== select mission =====
    const onClickMission = (missionNo) => {
        const m = MISSION_META[missionNo];
        setSelectedMission(m);
        setCurrentMission(m.no);
        resetPass();
        setScreen("pass");
    };

    const onPassChange = (idx, raw) => {
        const v = (raw || "").replace(/\D/g, "").slice(-1);
        setPassDigits((prev) => {
            const next = [...prev];
            next[idx] = v;
            return next;
        });
        if (v && idx < 3) setTimeout(() => passRefs.current?.[idx + 1]?.focus?.(), 0);
    };

    const onPassKeyDown = (idx, e) => {
        if (e.key === "Backspace" && !passDigits[idx] && idx > 0) {
            setTimeout(() => passRefs.current?.[idx - 1]?.focus?.(), 0);
        }
    };

    useEffect(() => {
        if (screen !== "pass") return;
        if (!passComplete) return;
        setScreen("passBlack");
    }, [passComplete, screen]);

    const onClickCheckPass = async () => {
        if (!passComplete || isCheckingPass) return;

        setIsCheckingPass(true);
        setErrorText("");

        const expectedList =
            currentMission ? missionPasswords[currentMission] || [] : [];

        const ok = expectedList.includes(passCode);

        setTimeout(async () => {
            if (!ok) {
                setErrorText("รหัสไม่ถูกต้อง กรุณาลองอีกครั้ง");

                resetPass();
                setScreen("pass");
                setIsCheckingPass(false);

                setTimeout(() => passRefs.current?.[0]?.focus?.(), 50);
                return;
            }

            await submitPassSuccess();

            setPassedMissionSet((prev) => {
                const next = new Set(prev);
                next.add(currentMission);
                return next;
            });

            setErrorText("");
            resetPass();
            setSelectedMission(null);
            setScreen("home");
            setIsCheckingPass(false);
        }, 350);
    };






    const lockCards = passedMissionSet.size === 3;

    return (
        <div className="StampAgr">
            <div className={`missionStampPage screen-${screen}`}>
                {(!pageReady || !bgReady || !dataReady) && <div className="bgStampLoading" />}

                <img
                    className="missionStampImg"
                    src={bgSrc}
                    alt="mission"
                    style={{ opacity: pageReady && bgReady && dataReady ? 1 : 0, transition: "opacity .25s ease" }}

                />

                {pageReady && dataReady && (
                    <>
                        {screen === "home" && passedReady && (
                            <div className={`homeOverlay ${!passedReady ? "disabled" : ""}`}>
                                <div className="missionStampGrid">
                                    {[1, 2, 3].map((no) => {
                                        const m = MISSION_META[no];
                                        return (
                                            <button
                                                key={no}
                                                className={`mStampCard  ${passedMissionSet.has(no) ? "done" : ""}`}
                                                onClick={() => !lockCards && onClickMission(no)}
                                                type="button"

                                                disabled={lockCards || passedMissionSet.has(no)}
                                            >
                                                <div className="mStampCardTop">
                                                    <img src={m.icon} alt="" className="mStampCardImg" />
                                                </div>

                                            </button>
                                        );
                                    })}
                                </div>




                            </div>
                        )}

                        {(screen === "pass" || screen === "passBlack") && selectedMission && (
                            <>
                                {!cusNotfound && (<div className="stampBack" onClick={onClickฺBack}>‹</div>)}
                                <div className="missionStampInfoOverlay">

                                    <img
                                        className={`${!cusNotfound ? "missionStampInfoIcon" : "missionStampInfoIconNotFound"}`}
                                        src={selectedMission.Stamp}

                                    />
                                    {!cusNotfound && (<div className="missionInfoTitle">ให้เจ้าหน้าที่กรอกโค้ด<br />เพื่อร่วมกิจกรรม</div>)}
                                </div>
                            </>
                        )}

                        {(!cusNotfound && (screen === "pass" || screen === "passBlack")) && (
                            <>
                                <div className="expocodeStampAgrPanel">
                                    <div className="expocodeAgrRow">
                                        {passDigits.map((v, idx) => (
                                            <input
                                                key={idx}
                                                ref={(el) => (passRefs.current[idx] = el)}
                                                className="expocAgrodeInput"
                                                inputMode="numeric"
                                                value={v}
                                                onChange={(e) => onPassChange(idx, e.target.value)}
                                                onKeyDown={(e) => onPassKeyDown(idx, e)}
                                                maxLength={1}
                                                type="password"
                                            />
                                        ))}
                                    </div>

                                    <button
                                        type="button"
                                        className={`stampSubmitBtn ${passComplete ? "enabled" : "disabled"}`}
                                        disabled={!passComplete}
                                        onClick={onClickCheckPass}
                                    >
                                        ร่วมกิจกรรม
                                    </button>
                                    {errorText && (
                                        <div className="stamperrorText">
                                            {errorText}
                                        </div>
                                    )}
                                </div>
                            </>
                        )}

                        {screen === "passBlack" && (
                            <div
                                className={`expoAgrenterHit ${passComplete && !isCheckingPass ? "enabled" : "disabled"}`}
                                onClick={onClickCheckPass}
                                role="button"
                            />
                        )}


                    </>
                )}
            </div>
        </div>
    );

}

export default connect((s) => ({ profile: s.profile }))(StampAgr);
